import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Button,
    Input,
    Select,
    Space,
    InputNumber, DatePicker, Drawer, Form,
    Typography
} from "antd";
import { filterOption, formatNumber } from "../../../utils/funcHelper";
import { FORMAT_DATE, TYPE_COMMISSION, TYPE_MODAL, TYPE_TICKET } from "../../../constants/constants";

import { consoleLogUtil } from "../../../utils/consoleLogUtil";
import dayjs from "../../../utils/dayjsConfig";
import { CloseOutlined, PlusOutlined, SaveOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;
const { Option } = Select;
const EkipDetailDrawer = ({ isOpen, onSave, type, onClose, randomID, data, employees, positions }) => {
    const [form] = Form.useForm();
    const [lstCommission, setLstCommission] = useState([]);
    const [isFormChanged, setIsFormChanged] = useState(false);

    const handleChangePosition = (value, options) => {
        consoleLogUtil("Selected position:", options?.rules?.length);
        if (options?.rules?.length > 0) {
            setLstCommission([...options?.rules?.map(item =>
                ({ ...item, label: `${formatNumber(parseInt(item.commission_value))} ${item?.commission_type === TYPE_COMMISSION[1].value ? 'vnd' : '%'}`, value: item.id }))
            ]);
        } else {
            setLstCommission([]);
        }
    }


    const onFinish = (values) => {
        consoleLogUtil("Final Form Values on Submit:", values);
        if (type === TYPE_MODAL.EDIT) {
            const ekips = values.ekips.map(e => ({
                ...e,
                type_income: lstCommission.find(item => item.value === e?.income_amount_id)?.commission_type,
                income_amount: lstCommission.find(item => item.value === e?.income_amount_id)?.commission_value,
            }));
            const updatedService = {
                ...data,
                ...values,
                ekips
            }
            consoleLogUtil("Updated Service on Edit:", updatedService);
            if (isFormChanged) {
                onSave(updatedService);
            } else {
                onClose();
            }
        } else {
            form.validateFields()
                .then((values) => {
                    const ekips = values.ekips.map(e => ({
                        ...e,
                        type_income: lstCommission.find(item => item.value === e?.income_amount_id)?.commission_type,
                        income_amount: lstCommission.find(item => item.value === e?.income_amount_id)?.commission_value,
                    }));
                    const updatedEkip = {
                        ...values,
                        ekips
                    }
                    onSave(updatedEkip);
                    onClose();
                })
        }
    }
    useEffect(() => {
        if (type === TYPE_MODAL.ADD) {
            form.resetFields();
            form.setFieldsValue({
                session_date: dayjs(),
            });
        } else if (type === TYPE_MODAL.EDIT && data) {
            form.setFieldsValue({
                session_date: data.session_date ? dayjs(data.session_date) : null,
                ekips: data.ekips?.length > 0 ? data.ekips.map(e => ({
                    ...e,
                    employee_id: e?.employee_name ?? '',
                    position_id: e?.position_name ?? '',
                    income_amount_id: e?.income_amount ? formatNumber(parseInt(e?.income_amount)) : '',
                })) : [],
                notes: data.notes ?? '',
            });
        }
    }, [type, randomID]);
    return (
        <Drawer
            title={type === TYPE_MODAL.ADD ? "Thêm Ekip thực hiện" : "Thông tin Ekip thực hiện"}
            width={600}
            onClose={onClose}
            open={isOpen}
            styles={{
                body: {
                    paddingBottom: 80,
                },
            }}
            extra={null
            }
        >
            <Form
                layout="vertical"
                form={form}
                onFinish={onFinish}
                onValuesChange={() => setIsFormChanged(true)}
            >
                <Row gutter={16}>

                    <Col span={12}>
                        <Form.Item
                            name="session_date"
                            label="Ngày thực hiện"
                            rules={[{ required: true, message: 'Vui lòng chọn ngày' }]}
                        >
                            <DatePicker
                                style={{ width: "100%" }}
                                format={FORMAT_DATE.DDMMYYYY}
                                disabled={type === TYPE_MODAL.EDIT}
                            />
                        </Form.Item>
                    </Col>

                </Row>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.List name="ekips">
                            {(fields, { add, remove }) => (
                                <>
                                    {fields.map(({ key, name, fieldKey, ...restField }) => (
                                        <Row gutter={16} key={key} align="middle">
                                            <Col span={1}>
                                                <Form.Item>
                                                    <Text>{name + 1}</Text>
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    {...restField}
                                                    name={[name, 'employee_id']}
                                                    fieldKey={[fieldKey, 'employee_id']}
                                                    rules={[{ required: true, message: 'Vui lòng chọn nhân viên' }]}
                                                >
                                                    {
                                                        type === TYPE_MODAL.EDIT ?
                                                            <Input disabled /> :
                                                            <Select
                                                                placeholder="Chọn nhân viên"
                                                                options={employees}
                                                                showSearch
                                                                filterOption={(input, option) =>
                                                                    option.label.toLowerCase().includes(input.toLowerCase())
                                                                }
                                                            />
                                                    }

                                                </Form.Item>
                                            </Col>
                                            <Col span={7}>
                                                <Form.Item
                                                    {...restField}
                                                    name={[name, 'position_id']}
                                                    fieldKey={[fieldKey, 'position_id']}
                                                    rules={[{ required: true, message: 'Vui lòng nhập vai trò' }]}
                                                >
                                                    {
                                                        type === TYPE_MODAL.EDIT ?
                                                            <Input disabled /> :
                                                            <Select
                                                                placeholder="Chọn vai trò"
                                                                options={positions}
                                                                showSearch
                                                                filterOption={(input, option) =>
                                                                    option.label.toLowerCase().includes(input.toLowerCase())
                                                                }
                                                                onChange={(value, options) => handleChangePosition(value, options)}
                                                            />
                                                    }

                                                </Form.Item>
                                            </Col>
                                            <Col span={6}>
                                                <Form.Item
                                                    {...restField}
                                                    name={[name, 'income_amount_id']}
                                                    fieldKey={[fieldKey, 'income_amount']}
                                                    rules={[{ required: true, message: 'Chọn công tua' }]}
                                                >
                                                    {
                                                        type === TYPE_MODAL.EDIT ?
                                                            <Input disabled /> :
                                                            <Select
                                                                placeholder="Chọn công tua"
                                                                options={lstCommission}
                                                                showSearch
                                                                filterOption={(input, option) =>
                                                                    option.label.toLowerCase().includes(input.toLowerCase())
                                                                }
                                                            />
                                                    }

                                                </Form.Item>
                                            </Col>
                                            <Col span={2}>
                                                <Form.Item>
                                                    {
                                                        type === TYPE_MODAL.EDIT ?
                                                            <span>{data?.type_income === TYPE_COMMISSION[0].value ? '%' : 'VNĐ'}</span> :
                                                            <Button
                                                                danger
                                                                icon={<CloseOutlined />}
                                                                onClick={() => remove(name)}
                                                                style={{ height: 30 }}
                                                            />
                                                    }

                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    ))}
                                    <Form.Item>
                                        {
                                            type === TYPE_MODAL.EDIT ? null :
                                                <Button
                                                    type="dashed"
                                                    onClick={() => add()}
                                                    block
                                                    icon={<PlusOutlined />}
                                                >
                                                    Thêm nhân viên
                                                </Button>
                                        }

                                    </Form.Item>
                                </>
                            )}
                        </Form.List>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            name="notes"
                            label="Ghi chú"
                        >
                            <Input.TextArea rows={4} placeholder="Nhập ghi chú" disabled={type === TYPE_MODAL.EDIT} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24} style={{ textAlign: "right" }}>
                        <Space>
                            <Button icon={<CloseOutlined />} onClick={onClose}>Đóng</Button>
                            {
                                type === TYPE_MODAL.EDIT ? null :
                                    <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
                                        Lưu
                                    </Button>
                            }

                        </Space>
                    </Col>
                </Row>
            </Form>
        </Drawer>
    )
}

export default EkipDetailDrawer;